import { ReactNode } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Button } from '@vk-hr-tek/ui/Button';
import { Icon } from '@vk-hr-tek/ui/Icon';

interface NotificationProps {
  onClose?: () => void;
  children: ReactNode;
}

export const Notification = ({ onClose, children }: NotificationProps) => (
  <Box
    color="accent.text.error"
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    fontSize={14}
    height={32}
    py="8"
    px="16"
    bgcolor="accent.bg.error"
    radius="m"
  >
    <Box alignItems="center" display="flex">
      <Icon name="error_circle_outline" size="20" />
      <Box ml="8">{children}</Box>
    </Box>
    <Button
      variant="tertiaryLight"
      onClick={onClose}
      size="extraSmall"
      icon={<Icon name="cancel" color="accent.text.error" size="20" />}
    />
  </Box>
);
